import { Routes, Route } from "react-router";
import { useSelector } from "react-redux";
import { HasPermission } from "Core/security"
import { Navigate } from "react-router-dom";

import DevicesMain from "Modules/devices/views/main";
import DeviceOverview from 'Modules/devices/views/overview';

const DevicesView = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "unt") && <Route path="list" element={<DevicesMain />} />}
                {HasPermission(user, "unt") && <Route path="overview/:id" element={<DeviceOverview />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default DevicesView